// extracted by mini-css-extract-plugin
module.exports = {"item":"item___2_h8I"};